import { IJoinFairPlayFailPayload } from '../../services/moderationActionCheck/joinFairPlay';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const JOIN_FAIR_PLAY_FAIL = 'FAIR_PLAY :: JOIN_FAIL';

export type TJoinFairPlayFailAction = IReduxAction<typeof JOIN_FAIR_PLAY_FAIL, IJoinFairPlayFailPayload>;

/**
 * @description Неуспешный ответ запроса на заявку участия в акции "Честная игра"
 */
export const joinFairPlayFail = actionGenerator<typeof JOIN_FAIR_PLAY_FAIL, IJoinFairPlayFailPayload>(
  JOIN_FAIR_PLAY_FAIL,
);
